export default __webpack_public_path__ + "static/media/avatar.60a2500f.jpg";